export class OptionsStaticData {
    public static readonly STANDALONE_RESOURCES_OFFER: string = 'RES_STANDALONE';
    public static readonly GAMING_OFFER: string = 'RO_GOOGLE';
    public static readonly PREMIUM_SERVICE_CHARACTERISTIC: string = 'BB_PREMIUM_SERVICE';
    public static readonly CHILI_ANTIVIRUS_CHARACTERISTIC: string = 'SRV_EXT_BB_ADDONS:EXT_BB_CHILI_ANTIVIRUS';
    public static readonly CLOUD_CHARACTERISTIC: string = 'SRV_EXT_BB_ADDONS:EXT_BB_CLOUD';
    public static readonly GOOGLE_WIFI_X1_OPTION_NAME: string = 'NEW_GOOGLE_WIFI_1PACK';
    public static readonly GOOGLE_WIFI_X1_INSTALMENT_OPTION_NAME: string = 'NEW_GOOGLE_WIFI_1PACK_INST';
    public static readonly TV_BOX_OPTION_NAME: string = 'NEW_STB_HUAWEI';
    public static readonly EXTRA_TV_SETUP_HELP_OPTION_NAME: string = 'INST_EXTRA_STB';
    public static readonly GOOGLE_NEST_RESOURCE_NAME: string = 'NEW_GOOGLE_NEST_ROUTER';
    public static readonly GOOGLE_NEST_ACCESS_POINT_RESOURCE_NAME: string = 'NEW_GOOGLE_NEST_ACCESS_POINT';
}
